
import React from 'react';
import { content } from '../data/content';
import { Rocket, Compass, Video, Package, RefreshCw, ArrowRight } from 'lucide-react';

const Process: React.FC = () => {
  const { process } = content;

  const getIcon = (index: number) => {
    switch (index) {
      case 0: return <Rocket className="w-6 h-6" />;
      case 1: return <Compass className="w-6 h-6" />;
      case 2: return <Video className="w-6 h-6" />;
      case 3: return <Package className="w-6 h-6" />;
      case 4: return <RefreshCw className="w-6 h-6" />;
      default: return <Rocket className="w-6 h-6" />;
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight mb-6">{process.title}</h2>
          {process.subtitle && (
            <p className="text-xl text-gray-500 font-medium max-w-2xl mx-auto">{process.subtitle}</p>
          )}
        </div>
        
        <div className="relative max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {process.steps.map((step, index) => (
              <div key={index} className="relative group">
                {/* Connector Line (Desktop) */}
                {index !== process.steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-[2px] bg-gray-200 z-0 transform -translate-y-1/2">
                    <ArrowRight className="absolute -right-1 -top-2.5 w-5 h-5 text-gray-300" />
                  </div>
                )}

                {/* Card */}
                <div className="h-full bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(0,0,0,0.05)] border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(0,0,0,0.1)] relative z-10 overflow-hidden">
                  {/* Hover Gradient */}
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-purple-50/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  <div className="relative z-10 flex flex-col items-center text-center h-full">
                    {/* Icon Circle */}
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-gray-50 to-gray-100 border border-gray-200 flex items-center justify-center mb-5 text-gray-600 group-hover:text-blue-600 group-hover:border-blue-100 group-hover:from-blue-50 group-hover:to-white transition-all duration-300 shadow-inner">
                      {getIcon(index)}
                    </div>

                    {/* Step Number */}
                    <div className="absolute top-2 right-4 text-4xl font-bold text-gray-100 select-none group-hover:text-blue-50 transition-colors duration-300">
                      0{step.id}
                    </div>

                    <h4 className="font-bold text-gray-900 mb-3 text-lg group-hover:text-blue-900 transition-colors">{step.title}</h4>
                    
                    <div className="w-8 h-1 bg-gray-100 rounded-full mb-4 group-hover:bg-blue-200 transition-colors"></div>
                    
                    <p className="text-sm text-gray-500 leading-relaxed font-medium">
                      {step.text}
                    </p>
                  </div>
                </div>

                {/* Mobile Connector */}
                {index !== process.steps.length - 1 && (
                  <div className="md:hidden flex justify-center py-4">
                    <ArrowRight className="w-6 h-6 text-gray-300 transform rotate-90" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
